import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlSegment, UrlMatchResult } from '@angular/router';
import { JournalMainComponent } from './journal-main.component';

export const JOURNAL_PATH = 'journal';

export function journalMainUrlMatcher(url: UrlSegment[]): UrlMatchResult | null {
  if (
    url.length > 0 &&
    url[0].path === JOURNAL_PATH &&
    (url.length === 1 || url[1].path === '' || url[1].path.includes('p-') || url[1].path === 'cat')
  ) {
    return { consumed: url };
  }
  return null;
}

const cmsRoutes: Routes = [
  {
    path: '',
    component: JournalMainComponent,
    data: {
      pageAnalytics: {
        env_template: 'journal-main'
      }
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(cmsRoutes)],
  exports: [RouterModule]
})
export class JournalMainRoutingModule {}
